import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route } from "react-router-dom";
import "./stylesheets/app.css";
import "./stylesheets/style.min.css";
import "./stylesheets/cards.css";
import App from "./app";
import registerServiceWorker from "./registerServiceWorker";

ReactDOM.render(
  <Router>
    <Route path="/" exact component={App} />
  </Router>,
  document.getElementById("app")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js